// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General page styling */
.notification-page {
    padding: 20px;
    width: 100%;
    background-color: #f5faff; /* Light blue background */
    font-family: Arial, sans-serif;
    color: #333;
  }
  
  body.dark-mode .notification-page {
    background-color: #1e1e1e; /* Dark background */
    color: #e4e4e4; /* Light text */
  }
  
  /* Top bar (header) styling */
  .top-bar-noti {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    background-color: #ffffff; /* Light theme background */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow */
    position: absolute;
    width: 100%;
    left: 0;
    margin-bottom: 24px;
    top: 0;
    z-index: 10;
  }
  
  body.dark-mode .top-bar-noti {
    background-color: #333333; /* Dark theme background */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5); /* More prominent shadow */
  }
  
  /* Header title styling */
  .top-heading {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #420cd2;
    flex: 1 1;
  }
  
  body.dark-mode .top-heading {
    color: #e4e4e4; /* Neutral white in dark mode */
  }
  
  .back-button {
    font-size: 16px;
    color: #420cd2;
    background: none;
    border: none;
    cursor: pointer;
  }
  
  body.dark-mode .back-button {
    color: #b3a1ff; /* Softer purple in dark mode */
  }
  
  .back-button:hover {
    color: #720cd2;
  }
  
  body.dark-mode .back-button:hover {
    color: #d4b3ff; /* Lighter hover effect for dark mode */
  }
  
  /* Page title */
  .page-title {
    flex: 1 1;
    text-align: center;
    color: #0b1a5b;
    font-size: 20px;
    margin: 0;
  }
  
  body.dark-mode .page-title {
    color: #e4e4e4;
  }
  
  /* Notifications list styling */
  .notification-list {
    padding: 0;
    margin: 0;
    list-style-type: none;
  }
  
  .notification-item {
    margin-bottom: 15px;
  }
  
  .notification-item .notification-box {
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  body.dark-mode .notification-item .notification-box {
    border: 1px solid #444444; /* Darker border for dark mode */
    background-color: #2e2e2e; /* Dark box background */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  }
  
  .notification-item .notification-box strong {
    color: #0b1a5b;
    font-size: 16px;
  }
  
  body.dark-mode .notification-item .notification-box strong {
    color: #e4e4e4;
  }
  
  .notification-item .notification-box p {
    color: #666666;
    font-size: 14px;
    margin: 8px 0 0;
  }
  
  body.dark-mode .notification-item .notification-box p {
    color: #b0b0b0;
  }
  
  /* Scrollbar styling for better dark mode experience */
  body.dark-mode ::-webkit-scrollbar {
    width: 8px;
  }
  
  body.dark-mode ::-webkit-scrollbar-track {
    background: #1e1e1e;
  }
  
  body.dark-mode ::-webkit-scrollbar-thumb {
    background: #444444;
    border-radius: 4px;
  }
  
  body.dark-mode ::-webkit-scrollbar-thumb:hover {
    background: #555555;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/NotificationPage.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,aAAa;IACb,WAAW;IACX,yBAAyB,EAAE,0BAA0B;IACrD,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,yBAAyB,EAAE,oBAAoB;IAC/C,cAAc,EAAE,eAAe;EACjC;;EAEA,6BAA6B;EAC7B;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB,EAAE,2BAA2B;IACtD,wCAAwC,EAAE,kBAAkB;IAC5D,kBAAkB;IAClB,WAAW;IACX,OAAO;IACP,mBAAmB;IACnB,MAAM;IACN,WAAW;EACb;;EAEA;IACE,yBAAyB,EAAE,0BAA0B;IACrD,wCAAwC,EAAE,0BAA0B;EACtE;;EAEA,yBAAyB;EACzB;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,SAAO;EACT;;EAEA;IACE,cAAc,EAAE,+BAA+B;EACjD;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc,EAAE,+BAA+B;EACjD;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc,EAAE,uCAAuC;EACzD;;EAEA,eAAe;EACf;IACE,SAAO;IACP,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA,+BAA+B;EAC/B;IACE,UAAU;IACV,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,yBAAyB,EAAE,gCAAgC;IAC3D,yBAAyB,EAAE,wBAAwB;IACnD,wCAAwC;EAC1C;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA,sDAAsD;EACtD;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":["/* General page styling */\n.notification-page {\n    padding: 20px;\n    width: 100%;\n    background-color: #f5faff; /* Light blue background */\n    font-family: Arial, sans-serif;\n    color: #333;\n  }\n  \n  body.dark-mode .notification-page {\n    background-color: #1e1e1e; /* Dark background */\n    color: #e4e4e4; /* Light text */\n  }\n  \n  /* Top bar (header) styling */\n  .top-bar-noti {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 20px;\n    background-color: #ffffff; /* Light theme background */\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow */\n    position: absolute;\n    width: 100%;\n    left: 0;\n    margin-bottom: 24px;\n    top: 0;\n    z-index: 10;\n  }\n  \n  body.dark-mode .top-bar-noti {\n    background-color: #333333; /* Dark theme background */\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5); /* More prominent shadow */\n  }\n  \n  /* Header title styling */\n  .top-heading {\n    font-size: 18px;\n    font-weight: bold;\n    text-align: center;\n    color: #420cd2;\n    flex: 1;\n  }\n  \n  body.dark-mode .top-heading {\n    color: #e4e4e4; /* Neutral white in dark mode */\n  }\n  \n  .back-button {\n    font-size: 16px;\n    color: #420cd2;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n  \n  body.dark-mode .back-button {\n    color: #b3a1ff; /* Softer purple in dark mode */\n  }\n  \n  .back-button:hover {\n    color: #720cd2;\n  }\n  \n  body.dark-mode .back-button:hover {\n    color: #d4b3ff; /* Lighter hover effect for dark mode */\n  }\n  \n  /* Page title */\n  .page-title {\n    flex: 1;\n    text-align: center;\n    color: #0b1a5b;\n    font-size: 20px;\n    margin: 0;\n  }\n  \n  body.dark-mode .page-title {\n    color: #e4e4e4;\n  }\n  \n  /* Notifications list styling */\n  .notification-list {\n    padding: 0;\n    margin: 0;\n    list-style-type: none;\n  }\n  \n  .notification-item {\n    margin-bottom: 15px;\n  }\n  \n  .notification-item .notification-box {\n    padding: 15px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: #ffffff;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  }\n  \n  body.dark-mode .notification-item .notification-box {\n    border: 1px solid #444444; /* Darker border for dark mode */\n    background-color: #2e2e2e; /* Dark box background */\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);\n  }\n  \n  .notification-item .notification-box strong {\n    color: #0b1a5b;\n    font-size: 16px;\n  }\n  \n  body.dark-mode .notification-item .notification-box strong {\n    color: #e4e4e4;\n  }\n  \n  .notification-item .notification-box p {\n    color: #666666;\n    font-size: 14px;\n    margin: 8px 0 0;\n  }\n  \n  body.dark-mode .notification-item .notification-box p {\n    color: #b0b0b0;\n  }\n  \n  /* Scrollbar styling for better dark mode experience */\n  body.dark-mode ::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  body.dark-mode ::-webkit-scrollbar-track {\n    background: #1e1e1e;\n  }\n  \n  body.dark-mode ::-webkit-scrollbar-thumb {\n    background: #444444;\n    border-radius: 4px;\n  }\n  \n  body.dark-mode ::-webkit-scrollbar-thumb:hover {\n    background: #555555;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
